/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TranslationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Force refresh translations
     * @returns boolean
     * @throws ApiError
     */
    public forceRefresh(): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/translations/refresh',
        });
    }

}
